module.exports = __webpack_public_path__ + "img/Weapon_82.7874809a.png";